<template>
	<el-table
			v-if="!loading &&tableData.length > 0"
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				prop="name"
				label="名称"
		>
		</el-table-column>

		<el-table-column
				v-for="(item, index) in titles"
				:key="index"
				:prop="item"
				:label="item">
				<!-- <template slot-scope="scope">
                    <span>{{scope.row[item].toFixed(2)}}kWh</span>
                </template> -->
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays,weekStart,weekEnd,dateFormat} from "../../../util/DateUtil";
	import {BuildingItemEnergy} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	export default {
		props: {
			loops: Array,
			range: String,
			date: Date
		},
		name: "Running",
		data() {
			return {
				loading:false,
				titles:["空调","照明","动力"],
				tableData:[]
			}
		},
		mounted() {
			this.requestData();
		},
		computed: {
			propsData(){
				return [
					this.date,
					this.range,
					this.loops,
					this.node
				]
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
		},
		methods: {
			//数据
			async requestData(){
				this.loading = true;
				let range = this.range;
				let promises = [];
				let currList = this.loops;
				currList.forEach((element) => {
					let obj = {
					buildingId: element.id,
					date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
					itemType: "",
					range: range.toUpperCase(),
					};
					promises.push(BuildingItemEnergy(obj));
				});
				let list = []
				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) =>
					r.data.data.result ? r.data.data.result : {}
					);
					pointsArray.forEach((item, index) => {
						let newdata = {}
						for(let i in item){
							newdata[i] = item[i].toFixed(2)+'kWh'
						}
						newdata.name = this.loops[index].name;
						list.push(newdata)
					});
					this.loading = false
					this.tableData = list
				});
			},
		},
		watch: {
			propsData(){
				this.requestData();
			},
			diagramStatus(n){
				if(this.$route.params.name === 'Extremum' && this.$route.params.tag === 'Suboption' ){
					if(n.type === 'excel' && this.tableData.length > 0){
						let data = [
							['名称']
						]
						this.titles.forEach(t => {
							data[0].push(t)
						})
						this.tableData.forEach(d => {
							data.push([d.name, ...this.titles.map(t => d[t])])
						})
						exportExcel(data, '分项能耗报表', [])
					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>